module.exports = __webpack_public_path__ + "static/media/progress.76abd26d.webp";